export default [
  {
    path: '/onboarding/kompack',
    name: 'kompack-partner-onboarding',
    component: () => import('@/views/pages/kompack/onboarding/OnboardingPage.vue'),
    meta: {
      resource: 'Kompack Partner Onboarding',
      action: 'manage',
      layout: 'full',
    },
  },
  // {
  //   path: '/kompack/partner/menubaru',
  //   name: 'kompack-partner-menubaru',
  //   component: () => import('@/views/pages/kompack/partner/Menubaru'),
  //   meta: {
  //     resource: 'Kompack Partner',
  //     action: 'manage',
  //   },
  // },
]
